import Vue from 'vue';
import excisePeriodTransformer from '../../transformers/excisePeriod';

const success = ({ data }) => excisePeriodTransformer.fetch(data);

const failed = (errors, reject) => {
  reject(errors);
};

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`reports/excise_periods/${id}/close`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/closeExcisePeriod.js